// extracted by mini-css-extract-plugin
module.exports = {"button":"Z","isRental":"aa","lightBGPrimary":"ab","secondary":"ac","iconButton":"ae","darkBGSecondary":"af","warning":"ah","outlined":"ai"};